import PrivacyStatement from "../components/pages/PrivacyStatement";

export default [
    {
        path: '/privacyverklaring',
        component: PrivacyStatement,
        name: 'privacy-statement'
    },
]
